module.exports = {"230828101":"香兰镇","230828102":"鹤立镇","230828103":"竹帘镇","230828104":"汤原镇","230828201":"汤旺乡","230828203":"胜利乡","230828208":"吉祥乡","230828209":"振兴乡","230828210":"太平川乡","230828211":"永发乡","230828400":"鹤立林业局","230828480":"香兰监狱","230828500":"汤原农场","230828501":"梧桐河农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230828.json
// module id = 706
// module chunks = 0